import { render } from "./presenters.vue?vue&type=template&id=1d0f1b64&scoped=true"
import script from "./presenters.vue?vue&type=script&lang=js"
export * from "./presenters.vue?vue&type=script&lang=js"

import "./presenters.vue?vue&type=style&index=0&id=1d0f1b64&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1d0f1b64"

export default script